import { render, staticRenderFns } from "./pbidConfirmFile.vue?vue&type=template&id=212a183e&"
import script from "./pbidConfirmFile.vue?vue&type=script&lang=js&"
export * from "./pbidConfirmFile.vue?vue&type=script&lang=js&"
import style0 from "./pbidConfirmFile.vue?vue&type=style&index=0&id=212a183e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports